import React from "react";

function ResetButton() {
  return (
    <div className="text-center">
      <button type="submit" className="btn btn-danger">
        Reset
      </button>
    </div>
  );
}
export default ResetButton;
